<template>
	<div class="stat-view" v-loading="loading" :element-loading-text="loadingText">
		<div class="header">
			<h2>统计报表（生成时间{{ nowDate }}）</h2>
		</div>
		<div v-show="!loading">
			<table class="table">
				<thead>
					<tr>
						<th>缺陷设备</th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
					</tr>
					<tr>
						<th>设备/缺陷</th>
						<th v-for="c in columns" :key="c" v-text="c"></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in data" :key="index">
						<td v-text="item.jt_name"></td>
						<td v-for="(c, c_index) in columns" :key="c_index + '_row'" v-text="getRowValue(c, item.rows)"></td>
					</tr>
				</tbody>
			</table>
		</div>

		<!--统计图-->
		<div>
			<el-row type="flex" class="charts" justify="center">
				<el-col :span="12" v-for="(itemData, index) in chartDataList" :key="index">
					<ve-pie :data="itemData"></ve-pie>
					<div style="text-align:center;">
						<label for v-text="itemData.title"></label>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import VePie from 'v-charts/lib/pie.common'
	import defectService from '../../service/defectService'
	import jobOrderService from '@/service/jobOrderService'
	import { getDefectOfDefectStatis } from '@/service/reportService'
	import moment from 'moment'
	export default {
		components: {
			VePie,
		},
		data() {
			return {
				chartDataList: [],
				loadingText: '',
				data: [],
				columns: [],
			}
		},

		computed: {
			/**
			 * 缺陷统计Id
			 */
			defect_statis_id() {
				return this.$route.query.defect_statis_id
			},
			/**
			 * 统计类型，按批次统计还是按工单统计。
			 */
			type() {
				return this.$route.query.type
			},
			nowDate() {
				return moment().format('yyyy年MM月DD日')
			},
		},
		methods: {
			/**
			 *
			 */
			getRowValue(columnName, rows) {
				var val = rows.find(t => t.type == columnName)
				if (val) {
					return val.value
				}

				return 0
			},
			loadingCallback(text) {
				this.loadingText = text
			},
			loadData() {
				// var p
				// if (this.type == 'job_order') {
				// 	p = jobOrderService.getJobOrderDefectStatisDataAsync(this.defect_statis_id, this.loadingCallback)
				// } else {
				// 	p = defectService.getDefectStatByStatisIdAsync(this.defect_statis_id, this.loadingCallback)
				// }

				var p
				if (this.type == 'job_order') {
					p = jobOrderService.getJobOrderDefectStatisDataAsync(this.defect_statis_id, this.loadingCallback)
				} else if (this.type == 'defect_stat') {
					p = getDefectOfDefectStatis(this.defect_statis_id)
				} else {
					p = defectService.getDefectStatByStatisIdAsync(this.defect_statis_id, this.loadingCallback)
				}

				p.then(res => {
					console.log('缺陷统计结果', res)
					res.forEach((v, i) => {
						var rows = []
						var chart_rows = []
						for (var attr in v) {
							if (attr == 'jt_id' || attr == 'jt_name') {
								continue
							}

							rows.push({
								type: attr,
								value: parseInt(v[attr]),
							})

							if (this.columns.findIndex(t => t == attr) == -1) this.columns.push(attr)
						}

						this.data.push({
							jt_id: v.jt_id,
							jt_name: v.jt_name,
							rows,
						})

						this.chartDataList.push({
							title: v.jt_name,
							columns: ['type', 'value'],
							rows: rows,
						})
					})

					this.loading = false
				})
			},
		},
		async created() {
			this.loading = true
			this.loadData()
		},
	}
</script>

<style lang="less" scoped>
	.stat-view {
		width: 1024px;
		margin: 0 auto;
	}
	.header {
		border-bottom: 1px #333 solid;

		> h2 {
			text-align: center;
		}
	}

	.condition {
		border-bottom: 1px #333 solid;
		padding: 10px 20px;
		color: #aaa;
	}

	.table {
		width: 100%;
		border-collapse: collapse;
		border-left: 1px #333 solid;
		border-bottom: 1px #333 solid;

		td,
		th {
			padding: 5px 3px;
			border-right: 1px #333 solid;
			border-top: 1px #333 solid;
			font-size: 12px;
			text-align: center;
		}
	}

	.table-rise {
		margin-bottom: 20px;
	}

	.table-rise .label {
		font-weight: bold;
		text-align: right;
		padding: 15px 0 0 0;
	}

	.table-rise .subline {
		border-bottom: 2px #000 solid;
	}

	.charts {
		margin-top: 50px;
	}
</style>
